// extracted by mini-css-extract-plugin
export var subheading = "dynamic-zone-component-module--subheading--z+due";